<script setup lang="ts">
import { defineEmits } from "vue";
import { useI18n } from "vue-i18n";

const emits = defineEmits<{
  (e: "backToCalendar"): void;
  (e: "nextDay"): void;
  (e: "prevDay"): void;
}>();

const { t } = useI18n();
</script>

<template>
  <div
    class="bg-white rounded-2xl border border-divider p-3 sm:p-4 shadow-sm flex flex-wrap items-center justify-between gap-2"
  >
    <button
      class="px-3.5 py-2 rounded-xl bg-secondary hover:bg-hover text-brown text-xs font-bold border border-divider transition-colors flex items-center gap-1.5"
      @click="emits('backToCalendar')"
    >
      {{ t("calculators.personal-date.controls.back-to-calendar") }}
    </button>
    <div class="flex items-center gap-1.5">
      <button
        class="px-3 py-2 rounded-xl bg-secondary hover:bg-hover text-brown text-xs font-semibold border border-divider transition-colors"
        @click="emits('prevDay')"
      >
        {{ t("calculators.personal-date.controls.prev-day") }}
      </button>
      <button
        class="px-3 py-2 rounded-xl bg-secondary hover:bg-hover text-brown text-xs font-semibold border border-divider transition-colors"
        @click="emits('nextDay')"
      >
        {{ t("calculators.personal-date.controls.next-day") }}
      </button>
    </div>
  </div>
</template>
